/*
 * @Auther: 罗耀祖
 * @Date: 2022-02-11 14:09:43
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-03-23 09:57:56
 * @name: 用户-登录
 * @Description: 用户-登录
 * @FilePath: \project\src\module\user\validator\login.js
 * @Author: desktop
 */
export const validator = [
  {
    key: 'mobile',
    description: '手机号',
    required: true,
    required_message: '手机号为必填项',
    required_toast: true,
    match: (e) => {
      if (!e) {
        return '请输入手机号';
      } else if (!(e.length === 11 && /^\d+$/.test(e))) {
        return '手机号格式错误';
      } else {
        return '';
      }
    },
    match_toast: true,
  },
  {
    key: 'password',
    description: '密码',
    required: true,
    required_message: '密码为必填项',
    required_toast: true,
    match: (e) => {
      if (!e) {
        return '请输入密码';
      } else {
        return '';
      }
    },
    match_toast: true,
  },
]